import { useGenericModal } from '..';
import {
  VoiceSelectorModal,
  VoiceSelectorModalProps,
} from './voice-selector-modal';

export const useVoiceSelectorModal = (
  props?: Partial<VoiceSelectorModalProps>
) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const modalComponent = (
    <VoiceSelectorModal
      modalRef={modalRef}
      onClose={closeModal}
      selectedValues={
        props?.selectedValues || {
          provider: '',
          audioModel: '',
          elevenlabsVoiceId: '',
          elevenlabsSimilarity: 0,
          elevenlabsSpeed: 0,
          elevenlabsStability: 0,
        }
      }
      onVoiceSelect={props?.onVoiceSelect}
    />
  );

  return {
    modalRef,
    openModal,
    closeModal,
    voiceSelectorModal: modalComponent,
  };
};
